import { usePromotersStayingTimeContext } from '../hooks/usePromotersStayingTimeContext'
import { cn } from '../libs/tailwindMerge'

export function PromotersStayingTimeCounter() {
  const { elapsedTime, activeCycle } = usePromotersStayingTimeContext()

  const hoursAmount = Math.floor(elapsedTime / (60 * 60))
  const minutesAmount = Math.floor((elapsedTime % (60 * 60)) / 60)
  const secondsAmount = elapsedTime % 60

  const hours = String(hoursAmount).padStart(2, '0')
  const minutes = String(minutesAmount).padStart(2, '0')
  const seconds = String(secondsAmount).padStart(2, '0')

  return (
    <div className={cn(
      'flex font-semibold',
      !activeCycle && 'text-gray-300',
    )}
    >
      <span className="font-[Roboto_Mono]">{hours[0]}</span>
      <span className="font-[Roboto_Mono]">{hours[1]}</span>
      <span className="font-[Roboto_Mono] mx-[0.12rem]">:</span>
      <span className="font-[Roboto_Mono]">{minutes[0]}</span>
      <span className="font-[Roboto_Mono]">{minutes[1]}</span>
      <span className="font-[Roboto_Mono] mx-[0.12rem]">:</span>
      <span className="font-[Roboto_Mono]">{seconds[0]}</span>
      <span className="font-[Roboto_Mono]">{seconds[1]}</span>
    </div>
  )
}
